import { UnplugIcon } from "lucide-react";
import "./McpServerTile.scss";
import { useNavigate, useParams } from "react-router-dom";
import { linkToToolPlugin } from "../../../../routes";

const McpServerTile = ({ toolPlugin }) => {
  const { workspaceId } = useParams();
  const nav = useNavigate();
  return (
    <div
      className="mcp_server_tile"
      onClick={() => nav(linkToToolPlugin(workspaceId, toolPlugin.uid))}
    >
      <div className="title_row">
        <div className="icon_container">
          <div className="icon_circle">
            <UnplugIcon size={24} color="#67748e" />
          </div>
        </div>
        <div className="title_column">
          <div className="title_value">{toolPlugin.name}</div>
          <div className="slug_container">
            <div className="slug" title={toolPlugin.websiteUrl}>
              {toolPlugin.websiteUrl}
            </div>
          </div>
        </div>
      </div>
      <div className="description_container">
        <div className="description">{toolPlugin.description}</div>
      </div>
    </div>
  );
};

export default McpServerTile;
